import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class DataTable extends Vue {
    @Prop({required: true}) data!: Array<{sensorName: string; value: number; time: number}>;
}
